export function createScript (src) {
  if (!document) return

  const script = document.createElement('script')

  script.setAttribute('src', src)
  script.setAttribute('type', 'text/javascript')

  // eslint-disable-next-line consistent-return
  return script
}

export function deleteScript (src) {
  if (!document) return

  const el = document.querySelector(`script[src="${src}"]`)

  if (el) {
    el.remove()
  }
}

function renderScript (src, location) {
  if (!document) {
    return Promise.reject()
  }

  if (document.querySelector(`script[src="${src}"]`)) {
    return Promise.resolve()
  }

  // eslint-disable-next-line no-unused-vars
  return new Promise((resolve, reject) => {
    const script = createScript(src)

    script.addEventListener('load', () => resolve())

    document[location].append(script)
  })
}

export function headScript (src) {
  return renderScript(src, 'head')
}

export function bodyScript (src) {
  return renderScript(src, 'body')
}
